import {
  LIST_ROLES_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// roleId -> {role}
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_ROLES_RESPONSE: {
      const s = { ...state }
      const roles = action.roles || []
      roles.forEach((r) => {
        s[r.id] = {
          ...r,
        }
      })
      return s
    }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
